<template>
  <v-layout class="container" column :class="[$vuetify.breakpoint.name]">
    <v-btn
      block
      color="#001F3F"
      dark
      :to="{ name: 'landing/woori-crowd', query: { referralCode: 'nice-check' } }"
      class="rounded-0"
    >
      <h1 class="white--text text-center">
        NEW!<br />
        우리동네크라우드펀딩<br />
        무이자 대출 신청하기
      </h1>
    </v-btn>
    <v-btn block color="white" :to="{ name: 'signup/agreements/nice' }" class="rounded-0">
      <h1 class="color--nice-black text-center">
        번개입금 선정산<br />
        신청하기
      </h1>
    </v-btn>
  </v-layout>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.container {
  height: calc(100svh - 100px);
  // row-gap: 20px;
  padding: 0;
}

h1 {
  font-weight: 900;
}

.container.mobile {
  h1 {
    font-size: 24px;
  }
}

.container.xs h1 {
  font-size: 24px;
}

.container.sm h1 {
  font-size: 48px;
}

.container.md h1 {
  font-size: 48px;
}
</style>
